import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import RoutesUtils from 'utils/RoutesUtils.class';
import routesAPI from './RoutesAPI';
import routesComponents from './RoutesComponent';

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};


const Routes = () => {
  const routes = [...routesComponents, ...routesAPI];

  return (
    <Fragment>
      {
        routes.map((item, key) => (
          <Route
            key={key}
            path={item.path}
            exact={item.exact}
            render={props => RoutesUtils.renderRoute(item, props)}
          />
        ))
      }
      <ScrollToTop />
    </Fragment>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/Routes.js